// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.elc-forms-title-tag {
  background-color: #0a56ae;
  color: white;
  border-radius: 4px;
  padding: 2px 5px;
}

.elc-subtitle {
  color: #0a56ae;
}

.content-wrapper-pov {
  border: 1px solid lightgray;
  padding: 15px;
  border-radius: 8px;
  margin-bottom: 15px;
}

.elc-submit-btn,
.elc-submit-btn:hover {
  background-color: #12a35d !important;
  color: #fff !important;
  padding: 6px 19px;
  border: 1px solid #12a35d !important;
}

.elc-cancel-btn,
.elc-cancel-btn:hover {
  background-color: #eff8ff !important;
  color: #175cd3 !important;
  padding: 6px 19px;
  border: 1px solid #175cd3 !important;
}

.elc-reject-btn,
.elc-reject-btn:hover,
.elc-reject-btn:active {
  background-color: #d92d20 !important;
  color: #fff !important;
  padding: 6px 19px;
  border: 1px solid #d92d20;
}`, "",{"version":3,"sources":["webpack://./../dashboard/src/components/ELCForms/ELCForms.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,2BAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;AACF;;AAEA;;EAEE,oCAAA;EACA,sBAAA;EACA,iBAAA;EACA,oCAAA;AACF;;AAEA;;EAEE,oCAAA;EACA,yBAAA;EACA,iBAAA;EACA,oCAAA;AACF;;AAEA;;;EAGE,oCAAA;EACA,sBAAA;EACA,iBAAA;EACA,yBAAA;AACF","sourcesContent":[".elc-forms-title-tag {\n  background-color: #0a56ae;\n  color: white;\n  border-radius: 4px;\n  padding: 2px 5px;\n}\n\n.elc-subtitle {\n  color: #0a56ae;\n}\n\n.content-wrapper-pov {\n  border: 1px solid lightgray;\n  padding: 15px;\n  border-radius: 8px;\n  margin-bottom: 15px;\n}\n\n.elc-submit-btn,\n.elc-submit-btn:hover {\n  background-color: #12a35d !important;\n  color: #fff !important;\n  padding: 6px 19px;\n  border: 1px solid #12a35d !important;\n}\n\n.elc-cancel-btn,\n.elc-cancel-btn:hover {\n  background-color: #eff8ff !important;\n  color: #175cd3 !important;\n  padding: 6px 19px;\n  border: 1px solid #175cd3 !important;\n}\n\n.elc-reject-btn,\n.elc-reject-btn:hover,\n.elc-reject-btn:active {\n  background-color: #d92d20 !important;\n  color: #fff !important;\n  padding: 6px 19px;\n  border: 1px solid #d92d20;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
